import StoredLayout from '../../layouts/StoredLayout'
import Breadcrumbs from './Breadcrumbs'
export default StoredLayout(Breadcrumbs)
